import classNames from "classnames";
import { useBookingModuleContext } from "PFApp/booking/parts/providers/booking_module_context_provider";
import { CalendarMode } from "PFApp/booking/types";
import { Button } from "PFComponents/button";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import React from "react";
import { useTranslation } from "react-i18next";

import { useBookingFormContext } from "../../../components/booking_form";
import { BookingFormMode } from "../../../components/booking_form/use_booking_form";
import cssToolbar from "../../toolbar.module.scss";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";

export const CreateBookingButton = () => {
  const { t } = useTranslation("bookingModule");
  const {
    calendarMode,
    calendarData: { data }
  } = useBookingsOverviewContext();
  const {
    modal: { open: openModal }
  } = useBookingFormContext();
  const { headerDisabled } = useBookingModuleContext();
  const { bookingCategories } = useBookingCategories();
  const hasWriteAccessToAtLeastOneCategory = bookingCategories.some((i) => !i.readonly);

  return (
    <Button
      icon="add"
      kind="secondary"
      title={t("bookings.create.createBooking")}
      className={classNames([cssToolbar.toolbarIconButton, cssToolbar.fullHeight])}
      onClick={() =>
        openModal(
          calendarMode === CalendarMode.Workforce
            ? {
                searchId: data.meta.search_id,
                total: data.meta.total,
                entries: data.entries
              }
            : {},
          { mode: BookingFormMode.Create }
        )
      }
      disabled={!hasWriteAccessToAtLeastOneCategory || headerDisabled}
    />
  );
};
